import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PlainTooltip } from "@similarweb/ui-components";

import { SAM_PAM_CHART_WIDTH_HEIGHT } from "./constants";

export const CircleWrapper = styled.div`
    position: relative;
    height: ${SAM_PAM_CHART_WIDTH_HEIGHT}px;
    width: ${SAM_PAM_CHART_WIDTH_HEIGHT}px;
    margin: 24px 80px;
`;

export const Circle = styled.span<{
    height: number;
    width: number;
    color: string;
    isCenterCircle?: boolean;
}>`
    position: absolute;
    display: block;
    border-radius: 100%;
    background: ${({ color }) => color};

    ${({ height, width }) => css`
        height: ${height}%;
        width: ${width}%;
    `}

    ${({ isCenterCircle }) =>
        isCenterCircle &&
        css`
            bottom: 0;

            transform: translate(-50%, 0);
            left: 50%;
            border: 1px solid ${colorsPalettes.carbon[0]};
        `}
`;

export const StyledTooltip = styled((props) => (
    <PlainTooltip
        cssClass={`${props.className} PlainTooltip-element`}
        {...props}
    />
))`
    margin-top: -6px !important;
    width: 221px;

    &:before {
        border-top: unset !important;
    }

    &:after {
        border-top: unset !important;
    }
`;
